// src/about.js
import { Navigate } from 'react-router-dom';

import './App.css';

const about = () => {
  return (
    
    <div className="about-page">

      {/* Hero Section */}
    <section className="heronew">
   <img src="img/blogleft.png" className="vectorall-left desktopvector" alt="left vector" />
  <img src="img/m2.png" className="vectorall-left mobilevector" alt="left vector" />
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>About us</span>
</h1>

<p className='subehad'>Evolution is not about being the best version of yourself someday. It is about being a better version of yourself every day, and something that enriches and nourishes every day is food. Hence, this symbiotic relationship we have with food is the most influential one in our evolution, and that is why we ensure that you eat right every day, so that you can evolve every day.</p>
  <p className="subtitle formobile">EVOLVE EVERYDAY</p>
  </div>
<img src="img/blogright.png" className="vectorabout-right" alt="right vector" />
</section>

 <section className="about-section green-section mobilewwd">
  <div className="about-flex">
    <div className="about-text">
      <h2>Why we do what we do</h2>
      <p>
        It is difficult for working professionals with hectic schedules to maintain a tasty & healthy diet
        leading to decline in overall Health & Wellness, so we identified a gap in the market and that’s how
        Paushtikk Switch was started.
      </p>
    </div>
    <div className="about-image-wrapper">
      <img src="/img/aboutpg.png" alt="Why We Do" className="about-icon-large" />
    </div>
  </div>
</section>

  <section className="about-section green-section desktopwwd">
  <div className="about-flex">
    <img src="/img/aboutpg.png" alt="Why We Do" className="about-icon-large" />
    <div className="about-text">
      <h2>Why we do what we do</h2>
      <p>
        It is difficult for working professionals with hectic schedules to maintain a tasty & healthy diet
        leading to decline in overall Health & Wellness, so we identified a gap in the market and that’s how
        Paushtikk Switch was started.
      </p>
    </div>
  </div>
</section>


      {/* How we got started */}
      <section className="about-section1">
        <img src="/img/OBJECTS.png" alt="How We Started" className="about-icon" />
        <h2 className='newsection'>How we got started</h2>
        <p>
        Picture three friends in Pune, fueled by a love for good food and a dream to make a difference. That's how Paushtikk Switch started, aiming to redefine diets with personalized, delicious meals tailored to individual tastes and health goals. From humble beginnings, they've grown, touching over 3000 lives. Paushtikk Switch isn't just a brand; it's a story of friendship, dedication, and the belief that everyone deserves to eat and live well. Each meal, made with care, brings health and happiness. Their journey continues, driven by passion and purpose. Evolve every day with Paushtikk Switch.
        </p>
      </section>

     <section className="about-section1 light-section">
  <h2 className='Newtext'>Our Founders</h2>
  <div className="founders-grid">

    {/* Founder 1 */}
    <div className="founder-card">
      <div className="foundersmall-card">
        <div className="image-wrapper">
          <img src="img/Component3.png" alt="Anandu Kumar" />
          <a
            href="https://www.linkedin.com/in/anandu-kumar-55a9457b"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-bar"
          >
            <img src="img/in.png" alt="LinkedIn" />
          </a>
        </div>
      </div>
      <h3><center>Anandu Kumar</center></h3>
      <p><center>Co-founder, CEO</center></p>
    </div>

    {/* Founder 2 */}
    <div className="founder-card">
      <div className="foundersmall-card">
        <div className="image-wrapper">
          <img src="img/Component2.png" alt="Suvidha Naik" />
          <a
            href="https://www.linkedin.com/in/suvidha-naik-42450790"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-bar"
          >
            <img src="img/in.png" alt="LinkedIn" />
          </a>
        </div>
      </div>
      <h3><center>Suvidha Naik</center></h3>
      <p><center>Co-founder, COO</center></p>
    </div>

    {/* Founder 3 */}
    <div className="founder-card">
      <div className="foundersmall-card">
        <div className="image-wrapper">
          <img src="img/Component1.png" alt="Peter Sabu" />
          <a
            href="https://www.linkedin.com/in/peter-sabu-6357b9179"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-bar"
          >
            <img src="img/in.png" alt="LinkedIn" />
          </a>
        </div>
      </div>
      <h3><center>Peter Sabu</center></h3>
      <p><center>Co-founder, CMO</center></p>
    </div>

  </div>
</section>


{/* Our Achievements Section */}
<section className="about-section1 achievements-section">
  <h2>Our Achievements</h2>

  <div className="achievement">
    <img src="/img/cer1.png" alt="TIE Nurture" />
    <div>
      <h3>TIE Nurture Accelerator Program</h3>
      <p>
       A six-month rigorous process-led program by industry titans for mentoring entrepreneurs to create impactful changes in all areas of their business. Nurture Mentors are successful entrepreneurs who run businesses themselves and are the leaders from their industry. Paushtikk Switch was selected to be a part of very few startups who successfully graduated this program.
      </p>
    </div>
  </div>

  <div className="achievement">
    <img src="/img/cer3.png" alt="Shark Tank India" />
    <div>
      <h3>Shark Tank India</h3>
      <p>
       Paushtikk Switch was invited to the Shark Tank India Season 2 for Pre TV auditions after successfully clearing all the screening rounds. Missed the final milestone of getting to the sharks, but hopefull to meet them some day in future.
      </p>
    </div>
  </div>
    <div className="achievement">
    <img src="/img/cer2.png" alt="Shark Tank India" />
    <div>
      <h3>Startup India Recognition</h3>
      <p>
        Paushtikk Switch is DPIIT recognised startup that is recognised as a startup by the Government of India in Healthcare and Lifesciences.
      </p>
    </div>
  </div>
</section>

    </div>
  );
};

export default about;


